import gql from 'graphql-tag'

const query = gql`
query loadAppConstants($type: ID!, $language: Language!) {
	cashAssist {
		loadAppConstants(language: $language, type: $type) {
			id
			label: value
			value: code
		}
	}
}`

export default query
